<Masonry layout={template}>

    {#each items as item}

    <MasonryItem area={item.area}>

        <svelte:component this={item.component} {...item.props} />

    </MasonryItem>

    {/each}

</Masonry>

<script>
    // components
    import Masonry from 'components/Masonry.html'
    import MasonryItem from 'components/MasonryItem.html'

    export default {
        components: {
            Masonry,
            MasonryItem
        },
        data() {
            return {
                template: '',
                items: []
            }
        }
    }
</script>